import { Avatar } from '@affine/component';
import { CurrentWorkspaceRoleBadge } from '@affine/core/components/current-workspace-role-badge';
import {
  type AuthAccountInfo,
  useCachedOwnAvatarUrl,
} from '@affine/core/modules/cloud';
import type { ReactNode } from 'react';

import * as styles from './index.css';

export const Account = ({
  account,
  badge,
}: {
  account: AuthAccountInfo;
  badge?: ReactNode;
}) => {
  const avatarUrl = useCachedOwnAvatarUrl(account);

  return (
    <div data-testid="user-info-card" className={styles.account}>
      <Avatar size={28} name={account.label} url={avatarUrl} />

      <div className={styles.content}>
        <div className={styles.nameRow}>
          <div
            className={styles.name}
            title={account.label}
            content={account.label}
          >
            {account.label}
          </div>
          {badge}
        </div>
        <div
          className={styles.email}
          title={account.email}
          content={account.email}
        >
          {account.email}
        </div>
        <CurrentWorkspaceRoleBadge
          className={styles.workspaceRole}
          dataTestId="user-info-workspace-role"
        />
      </div>
    </div>
  );
};
